// ============================================
// 10. src/pages/Home.jsx - ATUALIZADO COM POPUP
// ============================================
import React, { useContext, useEffect, useState } from 'react';
import { PagesContext } from '../contexts/PagesContext';
import { ConfigContext } from '../contexts/ConfigContext'; // Importando para pegar os números
import Carousel from '../components/Carousel';
import InfoSection from '../components/InfoSection';
import { X } from 'lucide-react'; // Ícone de fechar

function Home() {
  const { isComponentActive, fetchPageComponents } = useContext(PagesContext);
  const { config } = useContext(ConfigContext); // Pega os dados de configuração
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchPageComponents('home');
    
    // Ativa o popup assim que a tela carrega
    // Usamos um pequeno timeout para garantir uma transição suave
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Pega os números do config ou usa os padrões do seu código
  
  const whatsapp = config.contact_whatsapp || '(81) 98230-7332';

  return (
    <>
      {/* POPUP DE AVISO */}
      {showPopup && (
        <div style={popupStyles.overlay}>
          <div style={popupStyles.modal}>
            <button 
              onClick={() => setShowPopup(false)} 
              style={popupStyles.closeBtn}
              aria-label="Fechar aviso"
            >
              <X size={24} />
            </button>
            
            <div style={popupStyles.header}>
              <h3 style={popupStyles.title}>⚠️ Aviso Importante</h3>
            </div>
            
            <div style={popupStyles.content}>
              <p style={popupStyles.text}>
                Informamos que <strong>todos os contatos e reservas</strong> são realizados 
                exclusivamente através dos nossos números oficiais:
              </p>
              
              <div style={popupStyles.contactBox}>
                <p style={popupStyles.phoneItem}>
                  <span style={popupStyles.label}>WhatsApp:</span> 
                  <a href={`https://wa.me/55${whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer" style={popupStyles.link}>{whatsapp}</a>
                </p>
              </div>

              <button 
                onClick={() => setShowPopup(false)}
                style={popupStyles.okBtn}
              >
                Entendi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CONTEÚDO NORMAL DA HOME */}
      {isComponentActive('home', 'carousel') && <Carousel />}
      {isComponentActive('home', 'info_section') && <InfoSection />}
    </>
  );
}

// Estilos em objeto para não precisar mexer no CSS global
const popupStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    backdropFilter: 'blur(4px)'
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '2rem',
    maxWidth: '500px',
    width: '100%',
    position: 'relative',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    animation: 'fadeIn 0.3s ease-out'
  },
  closeBtn: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#64748b',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'color 0.2s'
  },
  header: {
    marginBottom: '1.5rem',
    textAlign: 'center',
    borderBottom: '2px solid #f1f5f9',
    paddingBottom: '1rem'
  },
  title: {
    color: '#0d9488', // Cor principal do seu site
    fontSize: '1.5rem',
    fontWeight: '700',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem'
  },
  content: {
    textAlign: 'center'
  },
  text: {
    color: '#334155',
    fontSize: '1.1rem',
    lineHeight: '1.6',
    marginBottom: '1.5rem'
  },
  contactBox: {
    backgroundColor: '#f0fdfa', // Fundo levemente verde
    padding: '1.5rem',
    borderRadius: '12px',
    marginBottom: '1.5rem',
    border: '1px solid #ccfbf1'
  },
  phoneItem: {
    margin: '0.5rem 0',
    fontSize: '1.2rem',
    color: '#1e293b',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.2rem'
  },
  label: {
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#64748b',
    fontWeight: '600'
  },
  link: {
    color: '#0d9488',
    textDecoration: 'none',
    fontWeight: '700'
  },
  okBtn: {
    backgroundColor: '#0d9488',
    color: 'white',
    border: 'none',
    padding: '0.75rem 2rem',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    width: '100%'
  }
};

export default Home;